import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AccordionComponent } from '../../../../shared/components/accordion/accordion.component';
import { FileUploadComponent } from '../file-upload/file-upload/file-upload.component';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NotificationService } from '../../../../shared/services/notification.service';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../../shared/constants/page.constants';
import { SharedService } from '../../../../shared/services/shared.service';
import { SectionsService } from '../../../../services/sections.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { UserService } from '../../../../services/user.service';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';

@Component({
  selector: 'ppl-documents',
  standalone: true,
  imports: [AccordionComponent,
    FileUploadComponent, AuthorizeDirective, ButtonComponent, ListTableComponent
  ],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.css'
})
export class DocumentsComponent  extends BaseComponent implements OnInit {

  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  tabId = TABS.Documents;
  entry = 'base';
  selectedLead: any;
  program: any;
  filedInfo: any;
  source!: string;
  steps: any;
  readonly = false;
  isEnrollmentEntry = false;

  @ViewChild('documentHistoryDialog') documentHistoryDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  documentHistoryData: any[] = [];
  documentHistoryCols = [
    { field: 'fileUploadDetailsId', header: 'Document ID', jsonpath: 'fileUploadDetailsId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'fileName', header: 'Document Name', jsonpath: 'fileName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'modifiedByName', header: 'Last Modified By', jsonpath: 'modifiedByName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'auditCreatedDate', header: 'Event Date', jsonpath: 'auditCreatedDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'operation', header: 'Action Performed', jsonpath: 'operation', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'acknowledgedDisplay', header: 'Acknowledged', jsonpath: 'acknowledgedDisplay', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];

  constructor(
    private notificationService: NotificationService,
    private sharedService: SharedService,
    private sectionsService: SectionsService,
    private authUtility: AuthorizationUtility,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.source = 'ppl-lead-documents';
    this.readonly = !this.authUtility.isSectionEditable(this.pageId, this.tabId, "FileUpload");
    // const getEntry = this.userService.getLeadEntry() ?? '';
    this.entry = this.userService.getLeadEntry() ?? '';
    this.entry = (this.entry === 'providers' ? 'provider' : (this.entry === 'participants' ? 'participant' : this.entry));
    this.isEnrollmentEntry =
      this.entry.toLowerCase() === 'participantenrollment' ||
      this.entry.toLowerCase() === 'providerenrollment';
    // switch(getEntry) {
    //     case STATIC_DATA.PARTICIPANT_ENROLLMENT:
    //       this.entry = STATIC_DATA.DOCUMENT_PARTICIPANT_ENROLLMENT_TYPE;
    //       break;
    //     case STATIC_DATA.PROVIDER_ENROLLMENT:
    //         this.entry = STATIC_DATA.DOCUMENT_PROVIDER_ENROLLMENT_TYPE;
    //         break;
    //     default:
    //       this.entry = this.userService.getLeadEntry() ?? '';
    // }
    // this.pageId = this.entry == 'participant' ? PAGE_CONSTANTS.PARTICIPANT_INFORMATION : PAGE_CONSTANTS.PROVIDER_INFORMATION;
    this.program = this.userService.getSelectedProgram();
    try {
      this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    } catch {
      this.notificationService.alert("error", "Error Fetching Data", "Error getting selected lead data");
    }
    this.getDocumentsUploaded();
    /* this.leadDetailsService.fetchLeadDocumentDetailsApi().subscribe((data)=>{
      console.log(data);
    }) */

     // this.getDocumentsUploaded(this.entry, this.selectedLead);
  }
  get isHistoryRole(): boolean {
    return this.userService.isSelectedRole(['PPL Admin', 'Compliance']);
  }

  filesUpdated() {
    console.log('Files List update');
    this.getDocumentsUploaded(true);
  }

  getDocumentsUploaded(hasUpdatedEntry?: boolean) {
    this.sharedService.getUploadedFileDetails(this.program.program_code, this.selectedLead, this.entry, hasUpdatedEntry).subscribe((data: any) => {
      console.log(data);
      this.filedInfo = data?.responsedata;
    })
  }

  openDocumentHistory(): void {
    this.sharedService.getDocumentHistory(this.program.program_code, this.selectedLead, this.entry).subscribe((data: any) => {
      const history = Array.isArray(data) ? data : (data?.responsedata ?? []);
      this.documentHistoryData = history.map((item: { operation?: string; acknowledged?: boolean; [key: string]: unknown }) => ({
        ...item,
        operation: item.operation ? item.operation.charAt(0).toUpperCase() + item.operation.slice(1).toLowerCase() : item.operation,
        acknowledgedDisplay: item.acknowledged ? 'Yes' : 'No',
      }));

      const dialogConfig: DialogConfig = {
        title: 'Document History',
        size: 'large',
        position: 'top',
        showClose: true,
        showButtons: false,
      };

      this.dialogSvc.openDialog(
        this.documentHistoryDialog,
        dialogConfig,
        () => {},
        () => {},
      );
    });
  }

}
